import { create } from 'zustand';

type IframeDialogStoreState = {
  link?: string;
  open: (link: string) => void;
  close: () => void;
};

export const useIframeDialogStore = create<IframeDialogStoreState>((set, get) => ({
  open: (link) => {
    set({ link: link });
  },
  close: () => {
    set({ link: undefined });
  }
}));
